export const iconFontAwesomeDevicesHardwareSdCard = (
	<i className="fa-solid fa-sd-card"></i>
);
